import React from "react";
import "../../../css/DesignSystem/SelectionControls/SelectionControls.css";

const normaliseOptions = (options = [], labelsMap = {}) =>
  options.map((option) =>
    typeof option === "object"
      ? option
      : { value: option, label: labelsMap?.[option] || option },
  );

const BorderlessCheckboxGroup = ({
  label,
  required = false,
  options = [],
  values = [],
  onChange,
  columns = 1,
  labelsMap = {},
}) => {
  const parsed = normaliseOptions(options, labelsMap);
  const toggle = (value) => {
    onChange(
      values.includes(value)
        ? values.filter((item) => item !== value)
        : [...values, value],
    );
  };

  return (
    <div className="smSelectionGroup">
      {label && (
        <div className="FP_Content_Semibold">
          {label}
          {required && <span className="text-error"> *</span>}
        </div>
      )}
      <div
        className="smSelectionGrid smSelectionGrid--Borderless"
        style={{ gridTemplateColumns: `repeat(${columns}, 1fr)` }}
      >
        {parsed.map((option) => (
          <label key={option.value} className="smBorderlessOption">
            <input
              type="checkbox"
              checked={values.includes(option.value)}
              onChange={() => toggle(option.value)}
            />
            <span className="smCheckboxBox" />
            <span className="smOptionLabel FP_Content">{option.label}</span>
          </label>
        ))}
      </div>
    </div>
  );
};

export default BorderlessCheckboxGroup;

